import en from '../locales/en/messages.json';
import { get, isNil, template } from 'lodash';

const appTranslations = en;

function translate(
  language: string,
  key: string,
  options?: {
    [x: string]: any
  }
) {
  if (options) {
    let message;

    if (!isNil(options.withPlural)) {
      const isSingular = options.withPlural === 1;
      message = get(appTranslations, key + (isSingular ? '.singular' : '.plural'));
    } else {
      message = get(appTranslations, key);
    }
    return template(message)(options);
  }

  return get(appTranslations, key);
}

export function applyTranslations(translationsData: {} = {}) {
  Object.keys(translationsData).forEach((key) => {
    appTranslations[key] = translationsData[key];
  });
}

export function t(key: string, options?: {}): string {
  return translate('en', key, options) || '';
}

// eslint-disable-next-line no-underscore-dangle
export function __t(key: string, options?: {}): string {
  // only used to filter already updated translations
  return translate('en', key, options) || '';
}
